import React from 'react';
import CDNImage from '../../utils/CDNImage';

const Box = props => {
	return (
		<div
			className='flex flex-col justify-start items-center w-full p-12'
			style={{
				background: `url('https://tcn-assets.hiperjob.com/ideal/images/${props.background_image}') white no-repeat center/100%`,
			}}
		>
			<CDNImage image_name={props.image_name} alt={props.image_name} />
			<p className='text-white font-Avenir-Black text-lgx text-center p-8 pb-4'>{props.p1}</p>
			<p className='text-white font-Avenir-Black text-lgx text-center py-4 px-8'>{props.p2}</p>
		</div>
	);
};

export default Box;
